import _ from "lodash";
import { getMemoizedLangFunction } from "Utils";

const getSubjectOptions = ({ subjects, t }) => {
  const options = _.map(subjects, ({ id, name }) => ({
    key: id,
    label: name,
  }));

  return [{ key: "all", label: t("common:all") }, ...options];
};

export const getSubjectOptionsMemoized = getMemoizedLangFunction(
  getSubjectOptions
);
